<template>
  <div class="add">
    <header class="headet-title">
      <div class="headet-title-box">
        <p>设置支付密码</p>
      </div>
    </header>
    <div class="add-body">
      <el-form ref="setPasswordForm" label-width="210px" :model="setPasswordForm" style="padding-left:40px" :rules="passRules">
        <el-form-item label="设置支付密码：" prop="password">
          <span id="password" />
        </el-form-item>
        <el-form-item label="重复支付密码：" prop="confirmPassword">
          <span id="confirmPassword" />
        </el-form-item>
        <el-form-item>
          <el-button class="sub" @click="setSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <input id="lic" type="hidden">
  </div>
</template>
<script>
import { submitSetPassword } from '@/api/security/security'
import Session from '@/utils/session'
import jQuery from 'jquery'
import pgeditorFn from '@/utils/pgeditor'
const pgeditor = pgeditorFn('_ocx_password', 1, '[0-9]*', '[0-9]{6,6}')
const pgeditor1 = pgeditorFn('_ocx_password1', 2, '[0-9]*', '[0-9]{6,6}')
window.pgeCtrl = pgeditor

export default {
  name: 'SetPassword',
  data() {
    return {
      setPasswordForm: {
        password: null,
        confirmPassword: null
      },
      passRules: {
        password: [
          { required: true, message: '请输入密码！', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请重复输入密码！', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    jQuery('#password').html(pgeditor.load())
    jQuery('#lic').val(pgeditor.setLicense())
    pgeditor.pwdClear()
    jQuery('#confirmPassword').html(pgeditor1.load())
    jQuery('#lic').val(pgeditor1.setLicense())
    pgeditor1.pwdClear()
  },
  methods: {
    setSubmit() {
      pgeditor.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
      pgeditor1.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
      const password = pgeditor.pwdResultSM()
      const pwd = pgeditor.pwdHash()
      // const confirmPassword = pgeditor1.pwdResultSM()
      const pwd1 = pgeditor1.pwdHash()
      if (pgeditor.pwdLength() === '0') {
        this.$message.error('请输入密码')
        return
      }
      if (pgeditor.pwdValid() === '1') {
        this.$message({
          message: '密码格式不正确，交易密码长度为6位',
          type: 'error'
        })
        return
      }
      if (pgeditor1.pwdLength() === '0') {
        this.$message.error('请再次输入密码')
        return
      }
      if (pgeditor1.pwdValid() === '1') {
        this.$message({
          message: '密码格式不正确，交易密码长度为6位',
          type: 'error'
        })
        return
      }
      if (pwd !== pwd1) {
        this.$message({
          message: '两次密码输入不不同',
          type: 'error'
        })
        pgeditor.pwdClear()
        pgeditor1.pwdClear()
        return
      }
      const param = {
        id: Session.getItem('customerId'),
        password: password,
        customerType: Session.getItem('customerType')
      }
      submitSetPassword(param).then(() => {
        this.$message({
          message: '修改密码成功',
          type: 'success'
        })
        this.$router.push({ path: '/security' })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style>
#password,
#confirmPassword {
  height: 40px;
}
#password input,
#confirmPassword input,
#_ocx_password,
#_ocx_password1 {
  border: 1px solid #dcdfe6;
  line-height: 40px;
  height: 40px;
  width: 100%;
  border-radius: 4px;
  padding: 0 15px;
}
</style>
<style scoped>
.add-body ::v-deep.el-form-item ::v-deep.ocx_style {
  border: 1px solid #dcdfe6;
  line-height: 40px;
  height: 40px;
  width: 200px;
  border-radius: 4px;
  padding: 0 15px;
}
.add-body ::v-deep.el-form-item ::v-deep.ocx_style:focus {
  outline: none;
  border: 1px solid #f56c6c;
}
.add {
  padding-bottom: 118px;
}
.headet-title {
  padding: 10px 30px 20px 30px;
}
.headet-title .headet-title-box {
  font-size: 16px;
  padding: 10px 0;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  border-bottom: 1px solid #dbdde2;
}
.headet-title-box {
  display: flex;
  align-items: center;
}
.headet-title-box > p:first-of-type {
  margin-right: 26px;
}

.add-body ::v-deep .el-input__inner {
  width: 236px;
  height: 32px;
  font-size: 13px;
  border-radius: 0px;
}
.sub {
  width: 118px;
  height: 40px;
  background: #e50007;
  color: #ffffff;
  border-radius: 0px;
  margin-top: 23px;
}
.hint {
  font-size: 12px;
  color: #a8a8a8;
}
.login .el-form-item {
  margin: 0;
}
</style>
